import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Case } from "./case";
import { Mediator } from "../../mediators/_types/mediator";

export class CaseMediator extends Resource {
    public override type = 'caseMediators';

    @prop()
    @required()
    public caseId!: string;

    public case: Case = new Case();

    @prop()
    @required()
    public mediatorId!: string;

    public mediator: Mediator = new Mediator();

    @prop()
    public isActive?: boolean = false;
}
